import { useState } from "react";
import { send } from "emailjs-com";
import html from "../EmailTemplate";
import { getEnvConfig } from "../utils/common";

export function useSignupForm() {
  const [formData, setFormData] = useState({ fullname: "", email: "" });
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  // Environment config
  const envConfig = getEnvConfig();
  const logoBase64 = `${envConfig.webUrl}emailHeader.png`;
  const logoBase = `${envConfig.webUrl}emailHeader.png`;
  const {
    emailConfigurations: { serviceId, userId, templateStarAura },
  } = envConfig;

  const sendEmail = async () => {
    try {
      await send(
        serviceId,
        templateStarAura,
        {
          html: html({ email: formData.email }, logoBase64, logoBase),
          to_email: formData.email,
        },
        userId
      );
      console.log("📧 Email sent successfully");
    } catch (error) {
      console.error("❌ Email sending failed:", error.text || error);
    }
  };

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { fullname, email } = formData;

    if (!fullname || !email) {
      setErrorMsg("Please fill all fields.");
      return;
    }
    if (!isValidEmail(email)) {
      setErrorMsg("Please enter a valid email address.");
      return;
    }

    setErrorMsg("");
    setLoading(true);
    try {
      const apiUrl = process.env.REACT_APP_API_URL || (window.location.hostname === 'localhost' ? 'http://localhost:5000' : '');
      const response = await fetch(`${apiUrl}/api/contacts`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email,
          fullname,
          os: "",
          fund_name: "",
          is_active: "",
          message: "",
          phone_number: "",
          created_by: "",
          created_date: new Date().toISOString(),
          updated_by: "",
          updated_date: "",
          is_deleted: 0,
          type: "star_aura",
        }),
      });

      if (!response.ok) {
        throw new Error(`Server returned ${response.status}: ${response.statusText}`);
      }

      const result = await response.json();
      console.log("✅ Contact saved to SQLite with ID:", result.id);

      await sendEmail();

      setSubmitted(true);
      setFormData({ fullname: "", email: "" });
    } catch (error) {
      console.error("❌ Error saving contact:", error);
      alert("❌ Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return {
    formData,
    loading,
    submitted,
    errorMsg,
    handleChange,
    handleSubmit,
  };
}
